// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.paramsStyle[data-v-14115fd0] { width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n", ""]);
// Exports
module.exports = exports;
